"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
function saveState(key, data) {
    sessionStorage.setItem(key, JSON.stringify(data));
}

function getSavedState(key) {
    var savedState = sessionStorage.getItem(key);

    return savedState ? JSON.parse(savedState) : null;
}

function clearSavedState(key) {
    sessionStorage.removeItem(key);
}

exports.default = { saveState: saveState, getSavedState: getSavedState, clearSavedState: clearSavedState };